export default __webpack_public_path__ + "static/media/plus_alt.04cc3229.svg";